import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
// Removed global CSS import for Netlify compatibility
// All styling is now inline with FC Frick design system

// Import auth debugging utilities (only loads in development)
import './lib/auth-debug'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
